import Vue from 'vue'

// 桥接请求日志-分页列表
export function getBridgeLogList(data) {
  return Vue.axios({
    url: '/api/bridge_log/list',
    method: 'post',
    data: { ...data }
  })
}

// 桥接请求日志-详情
export function getBridgeLogInfo(data) {
  return Vue.axios({
    url: '/api/bridge_log/info',
    method: 'post',
    data: { ...data }
  })
}

// 桥接请求日志-删除
export function deleteBridgeLog(data) {
  return Vue.axios({
    url: '/api/bridge_log/delete',
    method: 'get',
    params: { ...data }
  })
}
